import React, {useState, useEffect} from "react";
import axios from "axios";
import "./Forecast.css";
import WeatherForecastDay from "./WeatherForecastDay";

export default function Forecast(props){
let [loaded, setLoaded] = useState(false);
let [forecast, setForecast] = useState(null);

useEffect(() => {
    // set loaded to false
    setLoaded(false);
}, [props.coordinates]);
    // (Input=condition) if coordinates change

function handleResponse(response){
    console.log(response.data);
    setForecast (response.data.daily);
    setLoaded(true);
}

if (loaded) {
    return (
        <div className="WeatherForecast">
            <div className="row">
                {forecast.map(function(dailyForecast, index){
                    if (index > 0 && index < 6){
                        return(
                            <div key={index}>
                                <WeatherForecastDay data={dailyForecast}/>
                            </div>
                            );
                        } else return null;
                })}
            </div>
        </div>
        );  
    
} else {

    let longitude =props.coordinates.longitude;
    let latitude = props.coordinates.latitude;
    let url = `https://api.shecodes.io/weather/v1/forecast?lon=${longitude}&lat=${latitude}&key=482baea94563a32ca5b7f5ab8bto730f&units=metric`;
    axios.get(url).then(handleResponse);
    
    return null;}
}
